import React, { useCallback, useState } from "react";
import { withNamespaces } from "react-i18next";
import FindingsListItem from "./FindingsListItem";
import { Alert, Button, Col, Pagination, PaginationItem, PaginationLink, Row } from "reactstrap";
import { toast } from "react-toastify";
import FilteringComponent from "./FilteringComponent";
import FindingsService from "src/modules/3rd-party-management/apis/admin/FindingsService";
import { useMutation, useQuery } from "@tanstack/react-query";
import Spinner from 'react-bootstrap/Spinner';
import SortingComponent from "./SortingComponent";
import { map } from "lodash";

const FindingsList = (props) => {
    const [ filters, setFilters ] = useState({
        pageIndex: 1,
        pageSize: 25
    });
    const [totalPage, setTotalPage] = useState(0);

    const { t, supplierId, lng } = props;
    
    const [ items, setItems ] = useState([]);

    const fetchFindingsQuery = useQuery({
        queryKey: [
            '3rd-party-management-fetch-findings-list',
            supplierId,
            filters,
            lng
        ],
        queryFn: async () => {
            const service = FindingsService.getInstance();
            return await service.list(supplierId, {
                ...filters,
                language: lng
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching findings.'), {
                type: 'error',
            });
        },
        onSuccess: (data) => {
            setTotalPage(parseInt(data?.itemsCount || 0));
            setItems(data?.news || []);
        }
    });

    const handleToggleFlagStatusMutation = useMutation({
        mutationFn: async (selectedItemsIds) => {
            const service = FindingsService.getInstance();

            return await service.bulkToggleFlag({
                news  : selectedItemsIds
            });
        },
        onSuccess: () => {
            toast(t("Flag status of selected items changed successfully."), {
                type: "success",
            });
        },
        onError: () => {
            toast(t("An error occurred while updating."), {
                type: "error",
            });
        }
    });

    const handleFilterChange = useCallback((data) => {
        setFilters((currentState) => {
            return {
                ...currentState,
                ...data.data,
                pageIndex: 1
            }
        })
    }, []);

    const toggleCheckedItemsFlag = () => {
        const checkedItems = (items.filter((item) => !!item.checked)).map((item) => item.id);
        if(checkedItems.length > 0){
            handleToggleFlagStatusMutation.mutate(checkedItems, {
                onSuccess : () => {
                    const newList = [...items].map((item) => {
                        if(checkedItems.includes(item.id)){
                        return {
                            ...item,
                            checked : false,
                            flag  : !item.flag
                        }
                        }
                        return {...item};
                    });

                    setItems(newList);
                }
            });
        }
        else{
            toast(t('Please select at least one of the findings to continue'), {
                type: 'error',
            });
        }
    }

    return ( 
        <React.Fragment>  
            <Row className="findings-bulk-actions mb-3">
                {/* <Col sm="12" md="3">
                    <Button onClick={() => {
                        const status = ((items.filter((item) => !!item.checked)).length === items.length) ? false : true;
                        setItems([
                            ...items.map((item) => {
                                return {
                                    ...item,
                                    checked : status
                                }
                            })
                        ])
                        }} color="primary" outline>
                        {
                            ((items.filter((item) => !!item.checked)).length === items.length) ? (
                                t('Deselect All') 
                            ) : (
                                t('Select All') 
                            )
                        }
                    </Button>
                </Col> */}

                <Col sm="12" md="12" className="d-flex flex-row-reverse justify-content-start align-items-center">
                    {/* <Button 
                        disabled={ handleToggleFlagStatusMutation.isLoading } 
                        onClick={toggleCheckedItemsFlag} color="primary"
                    >
                        {handleToggleFlagStatusMutation.isLoading && (
                            <Spinner animation="border" variant="white" size="sm" style={{marginRight: '4px'}} />
                        )}
                        { t('Flag/Unflag Selected Items') }
                    </Button> */}

                    <FilteringComponent 
                        onChange={ handleFilterChange }
                    />

                    <SortingComponent 
                        onChange={ handleFilterChange }
                    />
                </Col>
            </Row>

            {fetchFindingsQuery?.data?.newsFetchingStatus &&
                <Alert  color='info'>
                    {
                        fetchFindingsQuery?.data?.newsFetchingStatus === "fetching_news" ? 
                        t("You will be notified once adverse news have been found.") :
                        fetchFindingsQuery?.data?.newsFetchingStatus === "have_news" ?
                        `${t("Last updated")}: ${fetchFindingsQuery?.data?.lastFetchDatetime}` :
                        ""
                    }
                </Alert>
            }

            <div className="findings-list d-flex flex-column mb-3">
                {!items.length && (
                    <Alert color="warning" className="text-center">
                        <p className="m-0">{t(`Findings list is empty.`)}</p>
                    </Alert>
                )}

                {
                    (items || []).map((item) => (
                        <FindingsListItem
                            key={item.id}
                            data={ item }
                            checked={ !!item?.checked }
                            onCheckStatusChanged={(status, item) => {
                                setItems((items) => {
                                    const itemIndex = items.findIndex((i) => i.id === item.id);
                                    const newItems = [...items];

                                    if(itemIndex > -1){
                                        newItems[itemIndex].checked = status;
                                    }

                                    return newItems;
                                });
                            }}
                        />
                    ))
                }
            </div>

            {filters.pageSize < totalPage && (
                <Row>
                    <Col sm="9" className="d-flex justify-content-start align-items-center">
                        <Pagination>
                            <PaginationItem disabled={filters.pageIndex <= 1}>
                                <PaginationLink
                                    previous
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (filters.pageIndex <= 1) {
                                            return;
                                        }
                                        setFilters((currentState) => ({
                                            ...currentState,
                                            pageIndex: currentState.pageIndex - 1
                                        }));
                                    }}
                                >
                                    {/* <i className="ri-arrow-left-s-line m-0"></i> */}
                                    {t('Back')}
                                </PaginationLink>
                            </PaginationItem>
    
                            {map(Array(Math.ceil(totalPage / filters.pageSize)), (_item, i) => (
                                <PaginationItem
                                    active={i + 1 === filters.pageIndex}
                                    key={"_pagination_" + i}
                                >
                                    <PaginationLink
                                        onClick={() => setFilters((currentState) => ({...currentState, pageIndex: i + 1}))}
                                        to="#"
                                    >
                                        {i + 1}
                                    </PaginationLink>
                                </PaginationItem>
                            ))}
    
                            <PaginationItem disabled={filters.pageIndex >= Math.ceil(totalPage / filters.pageSize)}>
                                <PaginationLink
                                    next
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (filters.pageIndex >= Math.ceil(totalPage / filters.pageSize)) {
                                            return;
                                        }
                                        setFilters((currentState) => ({
                                            ...currentState,
                                            pageIndex: currentState.pageIndex + 1
                                        }));
                                    }}
                                >
                                    {t('Next')}
                                    {/* <i className="ri-arrow-right-s-line"></i>  */}
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </Col>
    
                    <Col sm="3" className="d-flex justify-content-end align-items-center">
                        <p className="mb-2">
                            {`${t('Total Items')} ${totalPage}`}
                        </p>
                    </Col>
                </Row>
            )}

        </React.Fragment>
    );
};

export default withNamespaces()(FindingsList);
